
import React from 'react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface EmailFieldsProps {
  register: any;
  introText: string;
  updateIntroText: (text: string) => void;
  resetToDefault: () => void;
}

const EmailFields: React.FC<EmailFieldsProps> = ({ 
  register, 
  introText, 
  updateIntroText, 
  resetToDefault 
}) => {
  const { t } = useTranslation();
  
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="emailSubject">{t('email.subject')}</Label>
        <Input
          id="emailSubject"
          placeholder={t('email.subject')}
          defaultValue={t('email.defaultSubject')}
          {...register('emailSubject')}
        />
        <p className="text-xs text-gray-500 italic">
          {t('email.subjectHelp')}
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="personalizedMessage">{t('email.personalizedMessage')}</Label>
        <Textarea
          id="personalizedMessage"
          placeholder={t('form.placeholders.personalizedMessage')}
          {...register('personalizedMessage')}
          rows={2}
        />
        <p className="text-xs text-gray-500 italic">
          {t('email.personalizedMessageHelp')}
        </p>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="introText">{t('email.introText')}</Label>
        <Textarea
          id="introText"
          value={introText}
          onChange={(e) => updateIntroText(e.target.value)}
          rows={4}
          className="w-full"
        />
        <div className="flex justify-end">
          <Button 
            type="button" 
            variant="outline" 
            size="sm"
            onClick={resetToDefault}
            className="text-xs"
          >
            {t('common.resetToDefault')}
          </Button>
        </div>
        <p className="text-xs text-gray-500 italic">
          {t('email.introTextHelp')}
        </p>
      </div>
    </>
  );
};

export default EmailFields;
